import React from 'react';

import {
  Button,
  WysiwygField,
} from '../../../../components';

const CallToAction = ({ entity, setHover, overrideUrl, buttonPrimary }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'uri'], '#');
  const body = entity.getIn(['field_body', 0, 'processed'], '');

  const renderButton = () => {
    if (!linkTitle) {
      return;
    }
    if (setHover) {
      return (
        <Button href={overrideUrl || linkUri} onClick={() => { setHover(false); }} secondary withIcon buttonIcon>{linkTitle}</Button>
      );
    }
    if (buttonPrimary) {
      return (
        <Button href={overrideUrl || linkUri} primary withIcon buttonIcon>{linkTitle}</Button>
      );
    } else {
      return (
        <Button href={overrideUrl || linkUri} secondary withIcon buttonIcon>{linkTitle}</Button>
      );
    }
  };
  return (
    <div className="CallToAction">

      {title && (
        <h2 className="CallToAction__title">{title}</h2>
      )}

      <WysiwygField
        property="schema:text"
        className="CallToAction__body"
        html={body} />

      {renderButton()}
    </div>
  );
};

export default CallToAction;
